// A file dropped just outside a drop zone makes the browser open it in place
// of the app, dropping whatever was uploading. Page-level handlers cancel
// that. Drop zones handle (and cancel) their own events first, so an event
// that arrives here already cancelled belongs to one and is left alone; text
// or links dragged between inputs carry no "Files" and are left alone too.

const carriesFiles = event =>
  !!(
    event.dataTransfer &&
    event.dataTransfer.types &&
    Array.from(event.dataTransfer.types).includes("Files")
  );

export function onDragOver(event) {
  if (event.defaultPrevented || !carriesFiles(event)) return;
  event.preventDefault();
  // Shows the "not allowed" cursor: nothing happens if the user lets go here.
  event.dataTransfer.dropEffect = "none";
}

export function onDrop(event) {
  if (event.defaultPrevented || !carriesFiles(event)) return;
  event.preventDefault();
}

/**
 * Installs the guard on `target` (window by default).
 * @returns {() => void} removes it
 */
export function installFileDropGuard(target = window) {
  target.addEventListener("dragover", onDragOver);
  target.addEventListener("drop", onDrop);
  return () => {
    target.removeEventListener("dragover", onDragOver);
    target.removeEventListener("drop", onDrop);
  };
}
